import { Controller } from "@hotwired/stimulus"

// The live view of a device's screen — specs/38-fernzugriff.md §3.
//
// noVNC is loaded from `library`, an ES module of its own, and connects through
// the bridge on the Dokku host with the ticket in `url` (FZG-18, FZG-19). The
// ticket is good for one connection within 60 seconds, so there is no
// reconnecting here: looking again is a new view and a new log entry (FZG-21).
export default class extends Controller {
  static targets = ["screen", "status"]
  static values = { url: String, library: String, minutes: Number, messages: Object }

  async connect() {
    const { default: RFB } = await import(this.libraryValue)
    if (!this.element.isConnected) return

    this.rfb = new RFB(this.screenTarget, this.urlValue, { shared: true })
    // FZG-13 — nothing from this browser reaches the device. The device holds
    // that line itself (FZG-25); this only keeps the browser from trying.
    this.rfb.viewOnly = true
    // FZG-12 — the whole surface in the window, in its rotation (GER-27).
    this.rfb.scaleViewport = true
    this.rfb.addEventListener("connect", () => this.connected())
    this.rfb.addEventListener("disconnect", () => this.disconnected())

    // FZG-21 — a forgotten tab is otherwise an open line into a market.
    this.timeout = setTimeout(() => this.expire(), this.minutesValue * 60 * 1000)
  }

  disconnect() {
    clearTimeout(this.timeout)
    if (this.live) this.rfb.disconnect()
  }

  connected() {
    this.live = true
    this.everConnected = true
    this.say("connected")
  }

  // FZG-22 — a view that never got a picture says why rather than staying an
  // empty black box.
  disconnected() {
    this.live = false
    clearTimeout(this.timeout)
    if (this.expired) return

    this.say(this.everConnected ? "ended" : "unreachable")
  }

  expire() {
    this.expired = true
    if (this.live) this.rfb.disconnect()
    this.say("expired")
  }

  say(key) {
    this.statusTarget.textContent = this.messagesValue[key]
  }
}
